import {AppFwAppProviderProps, AppFwAppProviderPropsContext} from "../AppFwApp.tsx";
import MobileLayout from "./mobile/MobileLayout.tsx";
import DefaultAppFwLayout from "./default/DefaultAppFwLayout.tsx";
import {useContext} from "react";

export default function AppFwLayout() {
    const appFwAppProviderProps = useContext<AppFwAppProviderProps>(AppFwAppProviderPropsContext)
    if (appFwAppProviderProps.layout === "mobile") {
        return (
            <MobileLayout
                children={appFwAppProviderProps.children}
                slots={{
                    toolbarActions: appFwAppProviderProps.accountEl,
                }}
            />
        )
    } else {
        return (
            <DefaultAppFwLayout
                children={appFwAppProviderProps.children}
                slots={{
                    toolbarActions: appFwAppProviderProps.accountEl,
                }}
            />
        )
    }
}